import React from "react";
import { Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import RunablazeLogo from "../../../Assets/images/runablaze_2016.png";
import useWindowDimensions from "../../../Helpers/useWindowDimensions";

const styles = StyleSheet.create({
  container: {
    marginLeft: 12,
    marginRight: 12,
  },
  title: {
    fontFamily: "Muli",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: 19,
    lineHeight: "24px",
    letterSpacing: "0.4px",
    color: "#A4A6B3",
    opacity: 0.7,
    marginLeft: 12,
  },
  logo: {
    width: "100%",
    height: "100%",
  },
  mobileLogo: {
    width: "85%",
    height: "85%",
  },
});

export default function Logo() {
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  return (
    <Row
      className={isMobile ? undefined : css(styles.container)}
      horizontal="center"
      vertical="center"
    >
      <img
        className={isMobile ? css(styles.mobileLogo) : css(styles.logo)}
        src={RunablazeLogo}
        alt="Logo"
      />
    </Row>
  );
}
